import {DEFAULT_CURRENCY_CODE, NgModule} from '@angular/core';
import {CommonModule, CurrencyPipe, DatePipe} from '@angular/common';
import {EditFormComponent} from './edit-form.component';
import {NgxCurrencyDirective} from 'ngx-currency';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats} from '@angular/material/core';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {RouterModule} from '@angular/router';
import {EffectsModule} from '@ngrx/effects';
import {ZahlungEffects} from '../../store/effects/zahlung.effects';
import {ButtonModule, FormWrapperComponent, IconComponent, TooltipModule} from '@adnova/jf-ng-components';
import {FormBlockPaymentDataComponent} from './form-block-payment-data/form-block-payment-data.component';


export const MY_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  declarations: [
    EditFormComponent,
  ],
  imports: [
    RouterModule.forChild([{
      path: '',
      component: EditFormComponent,
    }]),
    EffectsModule.forFeature([
      ZahlungEffects,
    ]),
    CommonModule,
    NgxCurrencyDirective,
    MatDatepickerModule,
    ButtonModule,
    TooltipModule,
    FormWrapperComponent,
    FormBlockPaymentDataComponent,
    IconComponent,
  ],
  providers: [
    {provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR'},
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    DatePipe,
    MatDatepickerModule,
    CurrencyPipe,
  ]
})
export class EditFormModule {
}
